function OrderRowMetricsSkeleton() {
  return (
    <>
      <td className="nk-tb-col tb-col-xl text-right w-10 py-1 placeholder-glow">
        <span
          className="placeholder col-6 d-inline-block"
          data-testid="order-row-metrics-skeleton"
        />
      </td>
      <td className="nk-tb-col tb-col-xl text-right w-10 py-1 placeholder-glow">
        <span className="placeholder col-6 d-inline-block" />
      </td>
      <td className="nk-tb-col tb-col-xl text-right w-10 py-1 placeholder-glow">
        <span className="placeholder col-6 d-inline-block" />
      </td>
      <td className="nk-tb-col tb-col-md text-right w-20 py-1 pb-0 placeholder-glow">
        <span className="placeholder col-10 d-inline-block" />
      </td>
      <td className="nk-tb-col text-center w-10 py-1 placeholder-glow">
        <span
          className="placeholder rounded-circle d-inline-block"
          style={{ width: '40px', height: '40px' }}
        />
      </td>
    </>
  );
}

export default OrderRowMetricsSkeleton;
